import dayjs, { Dayjs } from "dayjs";
import { enqueueSnackbar, OptionsObject } from "notistack";
import { NOTIFICATION_AUDIO_ID } from "./const";

export const formatDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  return `${date.toLocaleDateString('en-GB').replace(/\//g, '-')} ${date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })}`;
};

export const isInPast = (dayjsDate: Dayjs) => {
  return dayjs().isAfter(dayjsDate.add(24, 'hours'))
}

export const isValidCoordinate = (long: number, lat: number) => {
  return long !== 0 && lat !== 0
}

export const underscoreToSpace = (text: string) => {
  if (!text) {
    return ''
  }
  return text.split('_').join(' ')
}

export function paginate(array: any[], page_size: number, page_number: number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

export const customLog = (message?: any, ...optionalParams: any[]) => {
  const isShowDebug = process.env.REACT_APP_DEV_MODE === 'true'
  if (!isShowDebug) {
    return
  }
  console.log(message, ...optionalParams);
}

export const showErrorToast = (message: string, options?: OptionsObject<"error">) => {
  enqueueSnackbar(message, {
    variant: 'error',
    style: { fontFamily: "Poppins" },
    ...options
  });
}

export const showSuccessToast = (message: string, options?: OptionsObject<"success">) => {
  enqueueSnackbar(message, {
    variant: 'success',
    style: { fontFamily: "Poppins" },
    ...options
  });
}

export const toRadian = (angle: number) => {
  return angle * (Math.PI / 180);
}

export const toDegree = (radian: number) => {
  return radian * (180 / Math.PI);
}

export const countTotalDays = (startTime: number, endTime: number, excludeDayIndexs = [6, 0]) => {
  let totalDays = 0;
  let current = dayjs.unix(startTime).startOf('day');
  const end = dayjs.unix(endTime).startOf('day');
  while (current.isBefore(end) || current.isSame(end)) {
    const dayOfWeek = current.day();
    if (!excludeDayIndexs.includes(dayOfWeek)) {
      totalDays++;
    }
    current = current.add(1, 'day');
  }

  return totalDays
}

export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const stopNotificationAudio = () => {  
  const audioElements = document.querySelectorAll(`audio.${NOTIFICATION_AUDIO_ID}`);
  audioElements.forEach((audio) => {
    if (!(audio as HTMLAudioElement).paused && (audio as HTMLAudioElement).currentTime > 0) {
      (audio as HTMLAudioElement).pause();
    }
    (audio as HTMLAudioElement).currentTime = 0;
  });

}